import { render, staticRenderFns } from "./ExtrusionResourceList.vue?vue&type=template&id=7da00edf&"
import script from "./ExtrusionResourceList.vue?vue&type=script&lang=js&"
export * from "./ExtrusionResourceList.vue?vue&type=script&lang=js&"
import style0 from "./ExtrusionResourceList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports